import { Link } from 'react-router-dom';
import { getHotExposes } from '@/lib/content';

export default function HotTicker() {
  const items = [...getHotExposes(6), ...getHotExposes(6)];
  return (
    <div className="border-b border-background-200 bg-background-50">
      <div className="container-page flex items-center gap-4 py-3">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-fire-line"></i>
          </span>
          热料滚动
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee-x gap-10">
            {items.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/expose/${item.id}`}
                className="whitespace-nowrap text-sm text-foreground-600 hover:text-primary-600 transition-colors"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}